var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('b-container',{staticClass:"bg-white",attrs:{"fluid":""}},[_c('b-row',_vm._l((_vm.barCharts),function(chart){return _c('b-col',{key:chart.key,staticClass:"mb-4"},[(Array.isArray(chart.data) && chart.data.length > 0)?_c('bar-stacked-simple',{attrs:{"config":chart}}):_vm._e()],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }